export default __webpack_public_path__ + "static/media/vlap-logo-text.92e980b9.svg";